"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compress = exports.compressRawBlock = void 0;

var _util = require("./util");

var _invariant = _interopRequireDefault(require("fbjs/lib/invariant"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var compressRawBlock = function compressRawBlock(opts) {
  return function (block) {
    (0, _invariant.default)(!(0, _util.instanceOfContentBlock)(block), 'block is not a raw block');
    var data = block.data,
        depth = block.depth,
        entityRanges = block.entityRanges,
        inlineStyleRanges = block.inlineStyleRanges,
        key = block.key,
        text = block.text,
        type = block.type;
    var compact = {};

    if (Object.keys(data || {}).length) {
      compact.data = data;
    }

    if (depth) {
      compact.depth = depth;
    }

    if (entityRanges === null || entityRanges === void 0 ? void 0 : entityRanges.length) {
      compact.entityRanges = entityRanges;
    }

    if (inlineStyleRanges === null || inlineStyleRanges === void 0 ? void 0 : inlineStyleRanges.length) {
      compact.inlineStyleRanges = inlineStyleRanges;
    }

    if (!opts.discardKeys && key) {
      compact.key = key;
    }

    if (text) {
      compact.text = text;
    }

    if (type !== 'unstyled') {
      compact.type = type;
    }

    if (_util.experimentalTreeDataSupport) {
      compact.children = (block.children || []).map(compressRawBlock(opts));
    }

    return compact;
  };
};

exports.compressRawBlock = compressRawBlock;

var compress = function compress(raw) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var rawContentState = raw;

  var _defaultCompressOpts$ = _objectSpread({}, _util.defaultCompressOpts, opts),
      convertToRaw = _defaultCompressOpts$.convertToRaw,
      discardKeys = _defaultCompressOpts$.discardKeys;

  if ((0, _util.instanceOfContentState)(raw)) {
    console.warn('Provided contentState instead of raw contentState.');
    rawContentState = convertToRaw(raw);
  } else if ((0, _util.instanceOfEditorState)(raw)) {
    console.warn('Provided editorState instead of raw contentState.');
    rawContentState = convertToRaw(raw.getCurrentContent());
  }

  var blocks = rawContentState.blocks.map(compressRawBlock({
    discardKeys: discardKeys
  }));

  if (!Object.keys(rawContentState.entityMap || {}).length) {
    return {
      blocks: blocks
    };
  }

  return {
    blocks: blocks,
    entityMap: rawContentState.entityMap
  };
};

exports.compress = compress;